const PATHS = {
  speaker: ['M2 6h3l4-3v10l-4-3H2Z', 'M11 5.5a4 4 0 0 1 0 5', 'M13 3.5a7 7 0 0 1 0 9'],
  muted: ['M2 6h3l4-3v10l-4-3H2Z', 'm11 6 4 4', 'm15 6-4 4'],
  pause: ['M4.5 3v10', 'M11.5 3v10'],
  microphone: [
    'M5.5 4a2.5 2.5 0 0 1 5 0v4a2.5 2.5 0 0 1-5 0Z',
    'M3.5 7.5V8a4.5 4.5 0 0 0 9 0v-.5',
    'M8 12.5V15',
    'M5.5 15h5',
  ],
  stop: ['M4 4h8v8H4Z'],
  undo: ['m5 2-3 3 3 3', 'M2 5h7a4 4 0 0 1 0 8H7'],
  redo: ['m11 2 3 3-3 3', 'M14 5H7a4 4 0 0 0 0 8h2'],
  upload: ['M8 11V2', 'm4.5 5.5 3.5-3.5 3.5 3.5', 'M2 10v4h12v-4'],
  image: ['M2 2.5h12v11H2Z', 'm2 11 3.5-3.5 2.5 2.5 2-2 4 4', 'M9.75 5.5h.01'],
  // What can be done with an image: its text read, between scan corners; or it described.
  'read-text': [
    'M2 5V3.25a.75.75 0 0 1 .75-.75H5',
    'M11 2.5h2.25a.75.75 0 0 1 .75.75V5',
    'M14 11v1.75a.75.75 0 0 1-.75.75H11',
    'M5 13.5H2.75a.75.75 0 0 1-.75-.75V11',
    'M5 6h6',
    'M5 8.25h6',
    'M5 10.5h3.5',
  ],
  'describe-image': [
    'M14 9.5v4H2v-11h6.5',
    'm2 11 3.5-3.5 2.5 2.5 2-2 4 4',
    'M12.25 1.25c.27 1.5.9 2.13 2.5 2.5-1.6.37-2.23 1-2.5 2.5-.27-1.5-.9-2.13-2.5-2.5 1.6-.37 2.23-1 2.5-2.5Z',
  ],
  download: ['M8 2v9', 'm4.5 7.5 3.5 3.5 3.5-3.5', 'M2 10v4h12v-4'],
  paste: ['M6 3H3v11h10V3h-3', 'M6 2h4v3H6Z', 'M5.5 8h5', 'M5.5 10.5H9'],
  expand: ['M6 2H2v4', 'm2 2 4.5 4.5', 'M10 14h4v-4', 'm14 14-4.5-4.5'],
  collapse: ['M2 6h4V2', 'm6 6-4-4', 'M14 10h-4v4', 'm10 10 4 4'],
  copy: [
    'M6 5V2.75A.75.75 0 0 1 6.75 2h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75H11',
    'M2.75 6h6.5a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-6.5a.75.75 0 0 1-.75-.75v-6.5A.75.75 0 0 1 2.75 6Z',
  ],
  check: ['m3 8 3 3 7-7'],
  external: ['M9 2.5h4.5V7', 'm7 9 6.5-6.5', 'M6 2.5H2.5v11h11V10'],
  card: ['M2 3.5h12v9H2Z', 'M2 6.5h12', 'M4.5 10h2'],
  retry: ['M13 6a5.2 5.2 0 1 0 .1 4', 'M13 2v4H9'],
  close: ['m4 4 8 8', 'm12 4-8 8'],
  trash: ['M2.5 4.5h11', 'M6 4.5v-2h4v2', 'm4 4.5.7 9h6.6l.7-9', 'M6.75 7v4', 'M9.25 7v4'],
  globe: [
    'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z',
    'M1.5 8h13',
    'M8 1.5c1.7 1.8 2.6 4 2.6 6.5S9.7 12.7 8 14.5C6.3 12.7 5.4 10.5 5.4 8S6.3 3.3 8 1.5Z',
  ],
  clock: ['M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z', 'M8 4.5V8l2.5 1.5'],
  alert: ['M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z', 'M8 4.75V8.5', 'M8 11.25h.01'],
  chevron: ['m4.5 6.5 3.5 3.5 3.5-3.5'],
  message: ['M2.5 3.5h11v7.5H8L4.5 13.5V11h-2Z'],
  lines: ['M2.5 4.5h11', 'M2.5 8h8', 'M2.5 11.5h5'],
  // The lengths a rewrite can take, drawn as lines of text: as many, fewer, and more.
  'length-same': ['M2.5 4.5h11', 'M2.5 8h11', 'M2.5 11.5h7'],
  'length-shorter': ['M2.5 6h11', 'M2.5 10h6'],
  'length-longer': ['M2.5 3h11', 'M2.5 6.33h11', 'M2.5 9.67h11', 'M2.5 13h8'],
  letters: [
    'M1.5 12.5 4.75 3.5 8 12.5',
    'M2.75 9.5h4',
    'M14.25 7.5v5',
    'M14.25 10a2.25 2.5 0 1 1-4.5 0 2.25 2.5 0 0 1 4.5 0Z',
  ],
  desktop: ['M2 2.5h12v8H2Z', 'M8 10.5v3', 'M5 13.5h6'],
  // The desktop systems, drawn as what each is known by: the ⌘ key, four panes, a terminal.
  'system-mac': [
    'M6 6V4.5A1.5 1.5 0 1 0 4.5 6H6Zm0 0h4m-4 0v4m4-4V4.5A1.5 1.5 0 1 1 11.5 6H10Zm0 0v4m0 0h1.5A1.5 1.5 0 1 1 10 11.5V10Zm0 0H6m0 0v1.5A1.5 1.5 0 1 1 4.5 10H6Z',
  ],
  'system-windows': [
    'M2.5 2.5h4.75v4.75H2.5Z',
    'M8.75 2.5h4.75v4.75H8.75Z',
    'M2.5 8.75h4.75v4.75H2.5Z',
    'M8.75 8.75h4.75v4.75H8.75Z',
  ],
  'system-linux': ['M1.5 2.75h13v10.5h-13Z', 'm4.25 6.25 2 1.75-2 1.75', 'M8 10.25h3.5'],
  'system-chrome': [
    'M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0Z',
    'M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z',
    'M8 5.5h5.45',
    'm10.17 9.25-2.73 4.72',
    'M5.83 9.25 3.1 4.53',
  ],
  book: [
    'M3 2.5h8.5A1.5 1.5 0 0 1 13 4v9.5H4.5A1.5 1.5 0 0 1 3 12V2.5Z',
    'M3 12a1.5 1.5 0 0 1 1.5-1.5H13',
  ],
  user: [
    'M8 7.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z',
    'M2.75 13.75c.6-2.5 2.7-4 5.25-4s4.65 1.5 5.25 4',
  ],
  'sign-in': ['M9.5 2.5h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-3', 'm6 11 3-3-3-3', 'M9 8H2.5'],
  'sign-out': ['M6.5 13.5h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3', 'm10 11 3-3-3-3', 'M13 8H6.5'],
  sparkle: [
    'M8 2.5c.5 2.8 1.7 4 4.5 4.5-2.8.5-4 1.7-4.5 4.5-.5-2.8-1.7-4-4.5-4.5 2.8-.5 4-1.7 4.5-4.5Z',
  ],
  wand: [
    'm2.5 13.5 8.5-8.5',
    'M5.5 1.75v2.5',
    'M4.25 3h2.5',
    'M13 8.25v2.5',
    'M11.75 9.5h2.5',
    'M12.75 1.75v1.5',
    'M12 2.5h1.5',
  ],
  edit: ['M10.5 2.5 13.5 5.5 5.75 13.25 2.5 13.5l.25-3.25Z', 'm9 4 3 3'],
  // The built-in AI tools, each drawn as what it makes of the text.
  // The draft's formatting: bold, italics, strikethrough, code, links, underline, subscript,
  // superscript, more of it, code blocks, dividers, headings, and none.
  bold: ['M4.5 2.75h4.25a2.6 2.6 0 0 1 0 5.25H4.5Z', 'M4.5 8h5a2.6 2.6 0 0 1 0 5.25h-5Z'],
  italic: ['M7.5 2.75h5', 'M3.5 13.25h5', 'm10 2.75-4 10.5'],
  strike: [
    'M2.5 8h11',
    'M11.25 4.75C10.75 3.6 9.6 2.75 8 2.75c-1.9 0-3.25 1-3.25 2.4 0 .95.55 1.6 1.45 2.05',
    'M10.85 9.35c.3.4.4.85.4 1.35 0 1.5-1.4 2.55-3.25 2.55-1.65 0-2.95-.8-3.4-2',
  ],
  code: ['m5.5 4.5-3.5 3.5 3.5 3.5', 'm10.5 4.5 3.5 3.5-3.5 3.5'],
  link: [
    'M6.75 9.25a2.85 2.85 0 0 0 4.03 0l2.12-2.12a2.85 2.85 0 0 0-4.03-4.03l-.6.6',
    'M9.25 6.75a2.85 2.85 0 0 0-4.03 0L3.1 8.87a2.85 2.85 0 0 0 4.03 4.03l.6-.6',
  ],
  unlink: [
    'M10 9.5 12.9 6.6a2.85 2.85 0 0 0-4.03-4.03L6.5 4.9',
    'M6 6.5 3.1 9.4a2.85 2.85 0 0 0 4.03 4.03l2.37-2.33',
    'm2.5 2.5 11 11',
  ],
  underline: ['M4.5 2.5v4.75a3.5 3.5 0 0 0 7 0V2.5', 'M3.5 13.5h9'],
  subscript: [
    'm2.5 3.5 6 7',
    'm8.5 3.5-6 7',
    'M10.75 10.5a1.3 1.3 0 0 1 2.5.5c0 .55-.45.95-1 1.45l-1.5 1.55h2.6',
  ],
  superscript: [
    'm2.5 5.5 6 7',
    'm8.5 5.5-6 7',
    'M10.75 2.5a1.3 1.3 0 0 1 2.5.5c0 .55-.45.95-1 1.45L10.75 6h2.6',
  ],
  more: [
    'M3.5 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z',
    'M8 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z',
    'M12.5 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2Z',
  ],
  'code-block': ['M2.5 2.5h11v11h-11Z', 'm6.25 6-2 2 2 2', 'm9.75 6 2 2-2 2'],
  divider: ['M2 8h12', 'M4.5 3.5h7', 'M4.5 12.5h7'],
  // The letter alone: the color it puts on words is drawn under it.
  'text-color': ['m4.25 10.5 3.75-8.5 3.75 8.5', 'M5.6 7.5h4.8'],
  table: ['M2.5 2.5h11v11h-11Z', 'M2.5 6.25h11', 'M2.5 9.75h11', 'M8 6.25v7.25'],
  heading: ['M3.5 3v10', 'M10.5 3v10', 'M3.5 8h7', 'M12.5 9.5 14 8.5v4.5'],
  'clear-format': ['M2.5 3h8', 'M6.5 3v10', 'm10 10 3.5 3.5', 'm13.5 10-3.5 3.5'],
  bullets: ['M6 4h7.5', 'M6 8h7.5', 'M6 12h7.5', 'M2.5 4h.5', 'M2.5 8h.5', 'M2.5 12h.5'],
  numbered: ['M7 4h6.5', 'M7 8h6.5', 'M7 12h6.5', 'M2.75 3H4v3', 'M2.5 10h1.75l-1.75 2.5h1.75'],
  checklist: ['m2.25 4 1.25 1.25L6 2.75', 'M8 4h5.5', 'M2.5 9.5h3v3h-3Z', 'M8 11h5.5'],
  gherkin: [
    'M3.25 12.75c-1.5-1.5-.5-4.75 2.5-7.75s6.25-4 7.75-2.5.5 4.75-2.5 7.75-6.25 4-7.75 2.5Z',
    'M6.5 9.5h.01',
    'M8.5 7.5h.01',
    'M10.5 5.5h.01',
  ],
  summary: ['M2.5 2.5h11', 'M2.5 5h11', 'M2.5 7.5h11', 'm6 10 2 1.75 2-1.75', 'M4.5 13.5h7'],
  wrap: ['M2.5 4h11', 'M2.5 8h9a2 2 0 0 1 0 4H8', 'm9.5 10.5-1.5 1.5 1.5 1.5', 'M2.5 12h3'],
  simplify: [
    'M2 4c1-1.5 2-1.5 3 0s2 1.5 3 0 2-1.5 3 0 2 1.5 3 0',
    'm6.5 7 1.5 1.25L9.5 7',
    'M2 11.5h12',
  ],
  'plain-text': ['M3 4.5v-2h10v2', 'M8 2.5v11', 'M6 13.5h4'],
  // The built-in tones, each drawn as how it sounds.
  quote: [
    'M2.75 5h3.5v3.5h-3.5Z',
    'M6.25 8.5c0 2.25-1.25 3.5-3 4',
    'M9.75 5h3.5v3.5h-3.5Z',
    'M13.25 8.5c0 2.25-1.25 3.5-3 4',
  ],
  smile: [
    'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z',
    'M5.5 9.5a3 3 0 0 0 5 0',
    'M6 6.5h.01',
    'M10 6.5h.01',
  ],
  coffee: [
    'M2.5 6h9v4a3.5 3.5 0 0 1-3.5 3.5H6A3.5 3.5 0 0 1 2.5 10Z',
    'M11.5 7h1a1.75 1.75 0 0 1 0 3.5h-1',
    'M5 2v2',
    'M8 2v2',
  ],
  briefcase: ['M2 5h12v8.5H2Z', 'M5.5 5V3h5v2', 'M2 9h12'],
  bolt: ['M9 1.5 3.5 9H8l-1 5.5L12.5 7H8Z'],
  heart: [
    'M8 13.5C4 11 1.75 8.5 1.75 6A3.25 3.25 0 0 1 8 4.5 3.25 3.25 0 0 1 14.25 6c0 2.5-2.25 5-6.25 7.5Z',
  ],
  megaphone: ['M2.5 6.5v3h2l5 3v-9l-5 3Z', 'M12 6a2.5 2.5 0 0 1 0 4', 'm4.5 9.5 1 4'],
  scale: [
    'M8 2.5v11',
    'M5 13.5h6',
    'M3 4.5h10',
    'M3 4.5 1.5 8.5a1.75 1.75 0 0 0 3 0Z',
    'm13 4.5-1.5 4a1.75 1.75 0 0 0 3 0Z',
  ],
  arrow: ['M2.5 8h11', 'm9.5 4 4 4-4 4'],
  flower: [
    'M8 14.5V8',
    'M8 8C5.5 8 4 6.25 4 3.5c1.5 0 2.75.6 3.4 1.6L8 2l.6 3.1c.65-1 1.9-1.6 3.4-1.6C12 6.25 10.5 8 8 8Z',
    'M8 12.5c-1.25-1.5-2.75-2-4.5-1.75.25 1.75 2 2.75 4.5 2.25',
  ],
  star: ['M8 1.75 9.9 5.6l4.25.6-3.07 3 .72 4.23L8 11.43l-3.8 2 .72-4.23-3.07-3 4.25-.6Z'],
  sun: [
    'M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    'M8 1.5v1',
    'M8 13.5v1',
    'M1.5 8h1',
    'M13.5 8h1',
    'm3.4 3.4.7.7',
    'm11.9 11.9.7.7',
    'm3.4 12.6.7-.7',
    'm11.9 4.1.7-.7',
  ],
  wink: [
    'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z',
    'M5.5 9.5a3 3 0 0 0 5 0',
    'M6 6.5h.01',
    'M9.25 6.5h1.5',
  ],
  cap: ['M1.5 6 8 3l6.5 3L8 9Z', 'M4.5 7.5v3c0 1 1.5 2 3.5 2s3.5-1 3.5-2v-3', 'M14.5 6v3.5'],
  ruler: [
    'M2 11.5 11.5 2 14 4.5 4.5 14Z',
    'm5 8.5 1.25 1.25',
    'm7 6.5 1.25 1.25',
    'm9 4.5 1.25 1.25',
  ],
  search: ['M7 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z', 'm10.75 10.75 3 3'],
  pin: ['M6 2.5h4', 'M6.5 2.5v4L4.5 9h7l-2-2.5v-4', 'M8 9v4.5'],
  hidden: [
    'm2 2 12 12',
    'M6.5 3.7A6.7 6.7 0 0 1 8 3.5c4 0 6.5 4.5 6.5 4.5a11 11 0 0 1-1.7 2.2',
    'M4.2 4.9C2.4 6.1 1.5 8 1.5 8S4 12.5 8 12.5c1.1 0 2.1-.3 2.9-.8',
    'M6.6 6.6a2 2 0 0 0 2.8 2.8',
  ],
  lock: ['M3.5 7.5h9v6h-9Z', 'M5.5 7.5V5.25a2.5 2.5 0 0 1 5 0V7.5'],
  play: ['M5 3.5v9l7-4.5Z'],
  plus: ['M8 3v10', 'M3 8h10'],
  folder: ['M1.5 3h4.25l1.5 1.75h7.25v8.25h-13Z', 'M1.5 6.75h13'],
  cloud: ['M11.67 13.17H6a4.67 4.67 0 1 1 4.47-6h1.2a3 3 0 1 1 0 6Z'],
  keyboard: ['M1.5 4h13v8h-13Z', 'M4 6.5h1', 'M7.5 6.5h1', 'M11 6.5h1', 'M4.5 9.5h7'],
  key: [
    'M5.25 13.75a2.75 2.75 0 1 0 0-5.5 2.75 2.75 0 0 0 0 5.5Z',
    'm7.2 9.05 6.3-6.3',
    'm11.25 4.75 1.75 1.75',
    'm9.5 6.5 1.25 1.25',
  ],
} as const satisfies Record<string, readonly string[]>;

export type IconName = keyof typeof PATHS;

export function Icon({ name }: { name: IconName }) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={16}
      height={16}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
